export const FETCH_DOMAINS_OVERVIEW_REQUEST = 'FETCH_DOMAINS_OVERVIEW_REQUEST';
export const FETCH_DOMAINS_OVERVIEW_SUCCESS = 'FETCH_DOMAINS_OVERVIEW_SUCCESS';
export const FETCH_DOMAINS_OVERVIEW_FAILURE = 'FETCH_DOMAINS_OVERVIEW_FAILURE';
